export class Price {
  readonly amount: number;
  readonly currency: string;

  constructor(amount: number, currency: string) {
    this.amount = amount;
    this.currency = currency;

    Object.freeze(this);
  }

  public static fromPayload({
    amount,
    currency,
  }: {
    amount: string;
    currency: string;
  }): Price {
    return new Price(parseFloat(amount), currency);
  }

  subtract(anotherPrice: Price): Price {
    if (this.currency !== anotherPrice.currency) {
      throw new Error(
        `Could not subtract price from different currencies: "${this.currency}" and "${anotherPrice.currency}"`,
      );
    }

    return new Price(this.amount - anotherPrice.amount, this.currency);
  }

  toJSON(): { amount: string; currency: string } {
    return {
      amount: this.amount.toString(),
      currency: this.currency,
    };
  }
}
